var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_26166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11C5.672 11 5 11.672 5 12.5C5 13.328 5.672 14 6.5 14C7.328 14 8 13.328 8 12.5C8 11.672 7.328 11 6.5 11ZM16 19V21C16 22.654 14.654 24 13 24H3C1.346 24 0 22.654 0 21V5.62096C0 3.24596 1.69 1.18396 4.019 0.717964L7.216 0.0789636C8.397 -0.157036 9.607 0.144964 10.537 0.907964C10.912 1.21496 11.202 1.59296 11.439 1.99996H12C14.206 1.99996 16 3.79396 16 5.99996V11C16 11.553 15.553 12 15 12C14.447 12 14 11.553 14 11V5.99996C14 4.89696 13.103 3.99996 12 3.99996V21.999H13C13.552 21.999 14 21.551 14 20.999V18.999C14 18.446 14.447 17.999 15 17.999C15.553 17.999 16 18.447 16 19ZM10 4.00096C10 3.39896 9.733 2.83596 9.269 2.45496C8.907 2.15796 8.461 2.00096 8.003 2.00096C7.872 2.00096 7.739 2.01396 7.607 2.03996L4.411 2.67896C3.014 2.95796 2 4.19596 2 5.62096V21C2 21.552 2.449 22 3 22H10V4.00096Z",
    fill: "#736A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 15C14 15.617 14.24 16.197 14.678 16.634L16.75 18.707C16.945 18.902 17.201 19 17.457 19C17.713 19 17.969 18.902 18.164 18.707C18.555 18.316 18.555 17.684 18.164 17.293L16.872 16H23C23.553 16 24 15.553 24 15C24 14.447 23.553 14 23 14H16.872L18.164 12.707C18.555 12.316 18.555 11.684 18.164 11.293C17.773 10.902 17.141 10.902 16.75 11.293L14.677 13.367C14.24 13.803 14 14.383 14 15Z",
    fill: "#736A85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_26166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.35d66cf0.svg";
export { ForwardRef as ReactComponent };